<template>
  <div class="columns is-multiline">
    <div class="column is-12" v-if="afficherLogistique">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('produitFace.otTechnique.title') }}
          </p>
        </header>
        <div class="card-content">
            <liste-ot-technique :idPatrimoine="face.id"
                  :ids="[face.id]"
                  :typePatrimoine="constantes.FACE"
                  :showPerPage="false">
            </liste-ot-technique>
        </div>
      </div>
    </div>
    <div class="column is-12" v-if="produit">
        <demande-logistique :produit="produit"></demande-logistique>
    </div>
  </div>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
import demandeLogistique from '@/components/catalogue/produitGeneral/logistique/demande_logistique';
import ListeOtTechnique from '@/components/emplacementTechnique/listeOtTechnique';
import { FACE } from '@/configuration/gabed/emplacement/emplacementConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'CatalogueProduitGeneralPresseLogistique',
  props: {
    produit: {
      type: Object,
      required: true,
    },
    face: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        FACE,
      },
    };
  },
  components: {
    demandeLogistique,
    ListeOtTechnique,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    afficherLogistique() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
